// src/utils/flattenMenuTree.js
export const flattenMenuTree = (tree) => {
  const menuMap = {};
  if (!Array.isArray(tree)) return menuMap;
  const traverse = (node) => {
    if (!node) return;
    if (node.subName) {
      menuMap[node.subName] = {
        visible: node.visible || false,
        actions: Array.isArray(node.actions)
          ? node.actions.reduce((acc, action) => {
              acc[action.name] = action.isEnabled;
              return acc;
            }, {})
          : {},
      };
    }
    if (node.children && Array.isArray(node.children)) {
      node.children.forEach(traverse);
    }
  };
  tree.forEach(traverse);
  return menuMap;
};
